import axios, { AxiosRequestConfig } from "axios";
import { buscaModelo, updateModeloBusca } from "../types/modelo";

export const getModelos = async (token: string): Promise<buscaModelo[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar modelos:", error);
    throw error;
  }
};

export const getModeloById = async (
  token: string,
  id: string
): Promise<buscaModelo> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar modelo:", error);
    throw error;
  }
};

export const createModelo = async (token: string, modeloData: FormData) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo`;
    const response = await axios.post(url, modeloData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar modelo:", error);
    throw error;
  }
};

export const updateModelo = async (
  token: string,
  id: string,
  modeloData: updateModeloBusca
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo/${id}`;
    const response = await axios.put(url, modeloData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar modelo:", error);
    throw error;
  }
};

export const deleteModelo = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/modelo/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir Modelo:", error);
    throw error;
  }
};
